var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsEnum, IsOptional, IsString, ValidateNested, } from 'class-validator';
import { MessagingDealer } from '../../../enums';
export class SendTextMessageMessageDto {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SendTextMessageMessageDto.prototype, "reservationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], SendTextMessageMessageDto.prototype, "receiverNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], SendTextMessageMessageDto.prototype, "content", void 0);
export class SendTextMessagesDto {
}
__decorate([
    IsEnum(MessagingDealer),
    __metadata("design:type", String)
], SendTextMessagesDto.prototype, "dealer", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], SendTextMessagesDto.prototype, "senderNumber", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SendTextMessagesDto.prototype, "title", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => SendTextMessageMessageDto),
    __metadata("design:type", Array)
], SendTextMessagesDto.prototype, "messages", void 0);
